import { useNavigate } from "react-router-dom";
import { buttonColors } from "../../utility/types/constant";
import { Stack, Button, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../redux/selectors/userSelector";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "1rem",
          color: "#fff",
          backgroundColor: "rgba(0, 0, 0, 0.87)",
        },
      },
    },
  },
});

const CreateCircleBtn = () => {
  const userData = useSelector(selectCurrentUser);

  const navigate = useNavigate();

  let totalCircle: any;

  if (userData?.unionLeaderOf && userData?.unionLeaderOf?.length) {
    totalCircle = userData?.unionLeaderOf?.length;
  }

  const circleCreateLimitMax = 2;

  const isLimitReached = totalCircle! >= circleCreateLimitMax;

  const handleNavigate = async () => {
    if (!isLimitReached) {
      navigate("/circle-create");
    }
  };

  const hasExistingCircle = totalCircle === 1;

  return (
    <ThemeProvider theme={theme}>
      <Stack>
        <Tooltip
          title={
            isLimitReached
              ? "You have reached the maximum limit of circles you can create."
              : ""
          }
          placement="top-start"
          disableHoverListener={!isLimitReached}
        >
          <span>
            <Button
              disabled={isLimitReached}
              variant="contained"
              size="small"
              onClick={handleNavigate}
              sx={{
                width: 230,
                mx: 1,
                backgroundColor: buttonColors.primary,
                fontSize: "1em",
                "&:hover": {
                  backgroundColor: buttonColors.primary,
                },
                mt: 1,
                mb: 1,
                textTransform: "none",
              }}
            >
              {hasExistingCircle
                ? "Launch Another Circle"
                : "Launch Your Circle"}
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </ThemeProvider>
  );
};

export default CreateCircleBtn;
